/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2102
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.InputType = undefined;
(function (e) {
  e[e.VALUE = 1] = "VALUE"
  e[e.STATEMENT = 3] = "STATEMENT"
  e[e.DUMMY = 5] = "DUMMY"
})(exports.InputType || (exports.InputType = {}))
